import { Field, FieldProps } from 'formik';
import React from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import { Help } from '../help';

export type CheckboxProps = Omit<
  FormControlProps &
    React.InputHTMLAttributes<HTMLInputElement> & {
      controlId: string;
      label?: string;
      centered?: boolean;
      className?: string;
      help?: string;
    },
  'type' | 'as' | 'value' | 'checked' | 'title' | 'onChange' | 'onBlur' | 'children'
>;

export const Checkbox = ({ controlId, label, centered, className = '', help, ...additionalAttributes }: CheckboxProps) => {
  return (
    <div className={`checkbox${className ? ` ${className}` : ''}`}>
      <Field name={controlId}>
        {({ field, meta }: FieldProps) => (
          <Form.Group controlId={controlId} className={`form-group ${centered ? `d-flex justify-content-center` : ''}`}>
            <div className="form-inline">
              <Form.Check>
                <Form.Check.Input
                  type="checkbox"
                  value={field.value || false}
                  checked={field.value || false}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  isValid={!meta.error && meta.touched}
                  isInvalid={!!meta.error && meta.touched}
                  {...additionalAttributes}
                />
                <Form.Label className={'ms-2'}>
                  {label && <Form.Label>{label}</Form.Label>}
                  {help && <Help placement="top">{help}</Help>}
                </Form.Label>
              </Form.Check>
            </div>
            <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
          </Form.Group>
        )}
      </Field>
    </div>
  );
};
